import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Compose conditional class lists and let later Tailwind utilities win over
 * earlier ones, so a caller's `className` can always override a component's
 * own defaults without `!important`. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
